const Gender = [
  { label: "Male", value: "1" },
  { label: "Female", value: "2" },
  { label: "Others", value: "3" },
  { label: "Prefer Not To Say", value: "4" },
];

export default Gender;
